export const getCurrentYear = () => {
    return new Date().getFullYear();
}

export const getCurrentQuarter = (date = new Date()) => {
    return `${Math.floor(date.getMonth() / 3 + 1)}Q`;
}
  
export const getCurrentMonth = (date = new Date()) => {
    const month = `${date.getMonth()+ 1}`;
    return `${month.length === 1 ? `0${month}` : month}`;
}

export const getDateRequestData = (month, year) => {
    let monthly;
    let quarterly;
    let data = {monthly: "", quarterly: ""};
    if (month === "1Q" || month === "2Q" || month === "3Q" || month === "4Q") {
        quarterly = `${month.slice(0, 1)}-${year}`;
        data.quarterly = quarterly;
    } else {
        monthly = `${month}-${year}`;
        data.monthly = monthly;
    }
    return data;
}

export const getYearsDropdownData = () => {
    const currentYear = new Date().getFullYear();
  const range = (start, stop, step) =>
    Array.from(
      { length: (stop - start) / step + 1 },
      (_, i) => start + i * step
    );
  return range(currentYear, 2022, -1);
}

export const formatDate = (date="") => {
    var months = [
        "Jan", "Feb", "Mar",
        "Apr", "May", "Jun",
        "Jul", "Aug", "Sep",
        "Oct", "Nov", "Dec"
    ];
    const currentDateTime = new Date(date);
    var month = months[currentDateTime.getMonth()]?.slice(0,3);
    var d = currentDateTime.getDate().toString();
    var year = currentDateTime.getFullYear();
    return (d.length == 1 ? `0${d}` : d) + ' ' + month +' '+year;
}